import React from 'react';

// A component that will smoothly animate to the height or width of its
// children when open, and to 0 when closed.
const SlideOutPanel: React.FC<{
  direction: 'vertical' | 'horizontal';
  open: boolean;
  children: React.ReactNode;
}> = ({ open, direction, children }) => {
  const style: React.CSSProperties = {
    display: 'grid',
    transitionProperty: 'grid-template-rows, grid-template-columns',
    transitionDuration: '0.3s',
    transitionTimingFunction: 'ease-out',
  };

  if (direction === 'vertical') {
    style.gridTemplateRows = open ? '1fr' : '0fr';
  } else {
    style.gridTemplateColumns = open ? '1fr' : '0fr';
  }

  return (
    <div style={style}>
      <div style={{ overflow: 'hidden' }}>{children}</div>
    </div>
  );
};

export default SlideOutPanel;
